import React, { useEffect, useState } from 'react';

export const Slide = ({ img, name, title, bio, onExpand, email, active }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded((prev) => !prev);
  };

  useEffect(() => {
    onExpand();
  }, [expanded, onExpand]);

  useEffect(() => {
    if (!active) {
      setExpanded(false);
    }
  }, [active]);

  const handleMailClick = () => {
    window.location.href = `mailto:${email}`;
  }

  return (
    <>
      <div style={{width: '100%', overflow: 'hidden', position: 'relative'}}>
        <img src={img} alt="slideImg" style={{width: '100%', aspectRatio: '390/273.1', height: '100%', objectFit: 'cover', objectPosition: 'top', display: 'block', filter: 'grayscale(100%)'}} />
        <div onClick={handleMailClick} style={{position: 'absolute', bottom: '50px', right: '0', background: '#25242D', padding: '12.5px 9px 9.5px', cursor: 'pointer'}}>
          <svg width="30" height="23" viewBox="0 0 30 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_220_278)">
              <path d="M28.612 1.521H1.396V21.933H28.612V1.521Z" stroke="white" strokeWidth="2.16" strokeMiterlimit="10"/>
              <path d="M1.396 1.521L15.004 13.617L28.612 1.521" stroke="white" strokeWidth="2.16" strokeMiterlimit="10"/>
            </g>
            <defs>
              <clipPath id="clip0_220_278">
                <rect width="28.282" height="21.478" fill="white" transform="translate(0.859131 0.984375)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', position: 'relative'}}>
        <div style={{position: 'relative', top: '-50px', left: '24px', color: '#25242D', background: 'white', padding: '16px', paddingRight: '25px'}}>
          <div style={{fontSize: '32px', textAlign: 'left', fontWeight: '400'}}>{name}</div>
          <div style={{fontSize: '18px', textAlign: 'left', fontWeight: '700', marginTop: '20px'}}>{title}</div>
          <div style={{fontSize: '18px', textAlign: 'left', fontWeight: '400', marginTop: '20px', maxHeight: expanded ? 'none' : '120px', display: expanded ? 'block' : '-webkit-box', '-webkit-box-orient': 'vertical', '-webkit-line-clamp': '3', overflow: 'hidden'}}>
            {bio}
          </div>
          <div style={{color: '#25242D', display: 'flex', alignItems: 'center', marginTop: '10px', textDecoration: 'underline', fontWeight: '700'}}>
            <span style={{cursor: 'pointer'}} onClick={handleExpand}>{expanded ? 'Back' : 'Read more'}</span>
          </div>
        </div>
      </div>
    </>
  );
}